'use client'

import { useQuery } from '@tanstack/react-query'
import { assetDataQuery } from '@/src/queries/keys/token-info/asset-data'
import { cn } from '@/src/utils/styles'
import { PriceDisplay } from '../price-display'
import { PriceChange } from '../ui/price-change'

interface TokenPriceIndicatorProps {
  chainId?: string
  denom?: string
  className?: string
}

export function TokenPriceAndChange({
  chainId,
  denom,
  className,
}: TokenPriceIndicatorProps) {
  // Note: This fetches data for every card — to avoid lags on first page load the query needs to be prefetched
  const { data: assetData } = useQuery({
    ...assetDataQuery({ chainId: chainId!, denom: denom! }),
    enabled: !!chainId && !!denom,
  })

  const price = assetData?.market_data?.current_price?.usd
  const priceChange = assetData?.market_data?.price_change_percentage_24h

  if (!chainId || !denom || price === undefined || priceChange === undefined) {
    return null
  }

  return (
    <div className={cn('flex flex-col items-end', className)}>
      <PriceDisplay
        price={price}
        formatOptions={{
          style: 'currency',
          currency: 'USD',
        }}
      />
      <PriceChange change={priceChange} size='sm' hideIfZero />
    </div>
  )
}

export function TokenPriceIndicator({
  chainId,
  denom,
  className,
}: TokenPriceIndicatorProps) {
  // Note: This fetches data for every card — to avoid lags on first page load the query needs to be prefetched
  const { data: assetData } = useQuery({
    ...assetDataQuery({ chainId: chainId!, denom: denom! }),
    enabled: !!chainId && !!denom,
  })

  const priceChange = assetData?.market_data?.price_change_percentage_24h

  if (!chainId || !denom || priceChange === undefined) {
    return null
  }

  return (
    <PriceChange
      change={priceChange}
      size='sm'
      className={className}
      hideIfZero={false}
    />
  )
}
